import React, { useState } from "react";
import { UserInfo } from "../../../interfaces/user";
import AddToWallet from "../AddToWallet/AddToWallet";
import QrCodeModal from "../../shared/Modals/QrCodeModal/QrCodeModal";
import { useConfig } from "../../../context/ConfigContext";
import { lightenColor } from "../../../utils/colorsUtils";
import "./LoyaltyHeader.scss";
import { useNavigate } from "react-router-dom";

interface LoyaltyHeaderProps {
  userInfo?: UserInfo;
  userPoints: number;
  restaurantName?: string;
  loading?: boolean;
}

const LoyaltyHeader: React.FC<LoyaltyHeaderProps> = ({
  userInfo,
  userPoints,
  restaurantName,
  loading = false,
}) => {
  const { config } = useConfig();
  const navigate = useNavigate();
  const primaryColor = config?.primaryColor || "#6366F1";
  const [qrModalVisible, setQrModalVisible] = useState<boolean>(false);

  const qrCodeUri = `data:image/png;base64,${userInfo?.qrCodeBytes || ""}`;

  const userName = userInfo
    ? `${userInfo.firstName || ""} ${userInfo.lastName || ""}`.trim()
    : "";
  const greeting = userName ? `Bonjour ${userName} !` : "Bonjour !";

  const handleQRCodePress = () => {
    if (!userInfo?.qrCodeBytes) return;
    setQrModalVisible(true);
  };

  const closeQrModal = () => {
    setQrModalVisible(false);
  };

  const handleConnectionPress = () => {
    navigate("/Authentification");
  };

  return (
    <div className="loyalty-header-card">
      <div
        className="loyalty-header-gradient"
        style={{
          background: `linear-gradient(135deg, ${primaryColor}, ${lightenColor(primaryColor, 20)})`,
        }}
      >
        <div className={`loyalty-header-content ${userInfo ? 'content-with-user' : ''}`}>
          {/* Left Column: Restaurant info and greeting */}
          <div className="info-column">
            {restaurantName && (
              <div className="restaurant-name">{restaurantName}</div>
            )}
            <div className="greeting">{greeting}</div>

            {!userInfo && (
              <button
                className="connection-button"
                onClick={handleConnectionPress}
              >
                <span className="sparkle">✨</span>
                <span className="connection-message">
                  {config?.showFidelity
                    ? "Connectez-vous pour accumuler des points !"
                    : "Connectez-vous pour Commander en ligne !"}
                </span>
              </button>
            )}
            {userInfo && (
              <div className="add-to-wallet-container">
                <AddToWallet compact />
              </div>
            )}
          </div>

          {/* Right Column: Points and QR Code */}
          <div className="action-column">
            {config?.showFidelity && (
              <div className="points-display">
                <div className="points-value">
                  {loading ? "..." : userPoints}
                </div>
                <div className="points-label">points</div>
              </div>
            )}

            {userInfo && (
              <button className="qr-button" onClick={handleQRCodePress}>
                <div className="qr-icon">
                  <img src={qrCodeUri} className="qr-image" alt="QR Code" />
                </div>
                <div className="qr-text">{userInfo?.qrCodeValue || ""}</div>
              </button>
            )}
          </div>
        </div>
      </div>

      {userInfo && (
        <QrCodeModal visible={qrModalVisible} onClose={closeQrModal} />
      )}
    </div>
  );
};

export default LoyaltyHeader;
